import { useMemo } from 'react';

import {
  isAdminOfOrganization,
  isAIEnabledForPremOrganization,
} from '@trello/business-logic/organization';

import type { AiBoardWorkspaceMembershipFragment } from './AiBoardWorkspaceMembershipFragment.generated';
import type { AiMemberAdminDataFragment } from './AiMemberAdminData.generated';

interface UseWorkspaceAIDataProps {
  board: AiBoardWorkspaceMembershipFragment | undefined;
  member?: AiMemberAdminDataFragment;
}

export function useWorkspaceAiData({
  board,
  member,
}: UseWorkspaceAIDataProps): {
  isAIEnabled: boolean | null | undefined;
  isWorkspaceAdmin: boolean | '' | null | undefined;
} {
  const workspace = board?.organization;
  const isAIEnabled = useMemo(
    () => workspace && isAIEnabledForPremOrganization(workspace),
    [workspace],
  );

  const isWorkspaceAdmin = useMemo(() => {
    return member && workspace && isAdminOfOrganization(member, workspace);
  }, [member, workspace]);

  return {
    isAIEnabled,
    isWorkspaceAdmin,
  };
}
